/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingDto } from '../../models/setting-dto';

export interface SettingAdminControllerGetSettingsV1$Params {
}

export function settingAdminControllerGetSettingsV1(http: HttpClient, rootUrl: string, params?: SettingAdminControllerGetSettingsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingDto>>> {
  const rb = new RequestBuilder(rootUrl, settingAdminControllerGetSettingsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SettingDto>>;
    })
  );
}

settingAdminControllerGetSettingsV1.PATH = '/api/v1/settings/admin';
